const ExpenseRoute = authentication => {
  return [
    // fiexed expense Routes
    {
      path: "/FixedExpense",
      name: "FixedExpense",
      meta: { name: "Fixed Expense" },
      beforeEnter: authentication,
      component: () => import("@/views/Branches/company/fixedExpense"),
    },
    {
      path: "/chargeexpense",
      name: "ChargeExpense",
      meta: { name: "Charge Expense" },
      beforeEnter: authentication,
      component: () => import("@/views/HQ/Charge/chargeExpense"),
    },
    {
      path: "/ExpenseEntry",
      name: "NewExpense",
      meta: { name: "New Expense" },
      beforeEnter: authentication,
      component: () => import("@/views/Branches/company/ExpenseEntry.vue"),
    },
    {
      path: "/expenses",
      name: "ShowExpenses",
      meta: { name: "Show Expenses" },
      beforeEnter: authentication,
      component: () => import("@/views/Branches/Reports/AllExpense"),
    },
  ];
};

export default ExpenseRoute;
